import { render } from "./Topbar.vue?vue&type=template&id=67d30d44&scoped=true"
import script from "./Topbar.vue?vue&type=script&lang=ts"
export * from "./Topbar.vue?vue&type=script&lang=ts"

import "./Topbar.vue?vue&type=style&index=0&id=67d30d44&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-67d30d44"

export default script